import { TableData } from '@/components/TableData/TableData';
import TableLayout from '@/layouts/TableLayout/TableLayout';
import { useCartsViewController } from './CartsViewController';
import { itemGenerator } from './TableItem';

export function CartsContainer() {
  const { uiState, actions } = useCartsViewController();

  return (
    <TableLayout
      isLoading={uiState.isLoading}
      body={
        <TableData
          columnHeaders={uiState.columnHeaders}
          items={uiState.items}
          rowItemGenerator={itemGenerator}
          paging={uiState.paging}
          onPageSelected={actions.onPageRequested}
          roundedTop={true}
          compact={true}
        />
      }
    />
  );
}
